import React from 'react';

import { SchDistfeatures } from '@/src/constants/SchDistfeature';

import type { ISchoolFeature } from '../home.interface';
import { Schooldistrictfeature } from './Schooldistrictfeature';

export const Schooldistrictfeatures = () => {
  return (
    <div className="container mx-auto">
      <h2 className="mt-24 text-center text-[34px] font-[500] text-[#3d3e40] md:mb-16 md:text-[54px]">
        School/District Features
      </h2>
      {SchDistfeatures.map((schdistfeature: ISchoolFeature, index: number) => (
        <Schooldistrictfeature
          schdistfeature={{
            ...schdistfeature,
            imageUrl: `/images/icons/schdistfeatures/feature-${index + 1}`,
          }}
          index={index + 1}
          key={index}
        />
      ))}
    </div>
  );
};
